import {bondRequestGridDisplay} from "./bond-request-grid";
import {showNewButton} from "./bond-request-new";
import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let asideMenu;
let formContainer;
let newId = 0;
let created = false;
let submitting = false;

// setup elements for new bond request form
const projectAutocomplete = async () => {
    try {
        const pac = $('.js-project-autocomplete');
        const pacDs = new kendo.data.DataSource({
            serverFiltering: false,
            transport: {
                read: {
                    type: 'post',
                    url: '/Forms/ProjectReview/ProjectAutoComplete'
                }
            }
        });
        pacDs.fetch();
        pac.kendoAutoComplete({
            placeholder: 'Search projects...',
            filter: 'contains',
            dataSource: pacDs,
            width: '100%'
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const nbAutocomplete = async () => {
    try {
        const pac = $('.js-nb-autocomplete');
        const pacDs = new kendo.data.DataSource({
            serverFiltering: false,
            transport: {
                read: {
                    type: 'post',
                    url: '/Sales/BondRequests/GetNorthBoundaryOpportunities'
                }
            }
        });
        pacDs.fetch();
        pac.kendoAutoComplete({
            placeholder: 'Search projects...',
            filter: 'contains',
            dataSource: pacDs,
            width: '100%',
            dataTextField : "OpportunityName",
            select(e) {
                $('[name="ProjectValue"]').data('kendoNumericTextBox').value(e.dataItem.Amount);
                $('[name="Description"]').val(e.dataItem.ScopeDescription);
            }
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const currencies = async () => {
    try {
        const pv = $('.js-currency');
        pv.css('text-align', 'right');
        pv.kendoNumericTextBox({
            format: 'c0',
            spinners: false
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const calculateProfit = () => {
    const profit = $('[name="Profit"]').data('kendoNumericTextBox');
    const pv = $('[name="ProjectValue"]').data('kendoNumericTextBox');
    const ld = $('[name="LaborDollars"]').data('kendoNumericTextBox');
    const md = $('[name="MaterialDollars"]').data('kendoNumericTextBox');
    const sd = $('[name="SubcontractorDollars"]').data('kendoNumericTextBox');
    const ed = $('[name="EquipmentDollars"]').data('kendoNumericTextBox');
    const od = $('[name="OtherDollars"]').data('kendoNumericTextBox');
    const profitValue = pv.value() - ld.value() - md.value() - sd.value() - ed.value() - od.value();
    profit.value(profitValue);
};

const profit = async () => {
    try {
        const profit = $('[name="Profit"]');
        const f = $('[name="ProjectValue"],[name="LaborDollars"],[name="MaterialDollars"],[name="SubcontractorDollars"],[name="EquipmentDollars"],[name="OtherDollars"]');
        f.on('blur', calculateProfit);
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const dropdowns = async () => {
    try {
        const bt = $('.js-bond-request-new-bond-type');
        const gcb = $('.js-gc-bonded');
        const pp1 = $('.js-penalty-provision-1');
        const pp2 = $('.js-penalty-provision-2');
        const pp3 = $('.js-penalty-provision-3');
        const btValues = [
            {text: 'Payment/Performance', value: '0'},
            {text: 'Bid Guaranty & Contract', value: '1'},
            {text: 'Bid Bond', value: '2'}
        ];
        const gcbValues = [
            {text: 'No', value: 0},
            {text: 'Yes', value: 1},
            {text: 'N/A', value: 2}
        ];
        const penaltyProvisionValues = [
            {text: "One Time", value: 0},
            {text: "Daily", value: 1},
            {text: "Per Business Day", value: 2},
            {text: "Weekly", value: 7},
            {text: "Monthly", value: 30},
            {text: "Quarterly", value: 90},
            {text: "Semi-Yearly", value: 183},
            {text: "Yearly", value: 365}
        ];
        bt.kendoDropDownList({
            optionLabel: 'Select bond type...',
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: btValues
        });
        gcb.kendoDropDownList({
            optionLabel: 'Select status...',
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: gcbValues
        });

        pp1.kendoDropDownList({
            optionLabel: 'Select status...',
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: penaltyProvisionValues
        })
        pp2.kendoDropDownList({
            optionLabel: 'Select status...',
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: penaltyProvisionValues
        })
        pp3.kendoDropDownList({
            optionLabel: 'Select status...',
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: penaltyProvisionValues
        })
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const bidPercentage = async () => {
    try {
        const bbp = $('.js-bond-request-new-bid-percentage');
        bbp.kendoNumericTextBox({
            format: '### \\%',
            spinners: true
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const dates = async () => {
    try {
        const rd = $('.js-date');
        rd.kendoDatePicker({
            format: 'MM/dd/yyyy'
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const originalBonds = async () => {
    try {
        const ob = $('.js-bond-request-new-original-bonds');
        ob.kendoNumericTextBox({
            format: 'n0',
            spinners: true
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const states = async () => {
    try {
        const stateDataSource = new kendo.data.DataSource({
            serverFiltering: false,
            transport: {
                read: {
                    type: 'post',
                    dataType: 'json',
                    url: '/Common/States'
                }
            }
        });
        stateDataSource.fetch();
        const s = $('.js-state');
        s.kendoDropDownList({
            optionLabel: 'Select state...',
            dataTextField: 'Text',
            dataValueField: 'Value',
            dataSource: stateDataSource,
            autoBind: false
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const tooltips = async () => {
    try {
        /*const ptt = $('.js-bond-request-new-principal-tooltip');
        ptt.kendoTooltip({
            autoHide: true,
            position: 'right',
            showOn: 'mouseenter',
            content: 'Operating Company as It Appears on the Contract'
        });*/
        const ldtt = $('.js-bond-request-new-labor-tooltip');
        ldtt.kendoTooltip({
            autoHide: true,
            position: 'right',
            showOn: 'mouseenter',
            content: 'Value includes Billed labor, Project Management, Controls, etc.'
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const specialBondFormMessage = (e) => {
    const msgp = $('.js-special-bond-message-text').parent();
    const vis = e.target.checked;
    if (vis) msgp.show();
    else msgp.hide();
};

const specialBondForm = async () => {
    try {
        const sbf = $('[name="SpecialBondForm"]');
        sbf.on('change', specialBondFormMessage);
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const documentation = async () => {
    try {
        const docs = $('.js-documentation')
            .kendoUpload({
                async: {
                    autoUpload: false,
                    saveUrl: 'SaveNewBondRequestAttachments',
                },
                dropZone: '.js-documentation-dropzone',
                validation: {
                    allowedExtensions: window.allowedFileTypes,
                },
                localization: {
                    invalidFileExtension:
                        'Attempted File Type is not supported. ' +
                        'Please upload under a supported file type, ' +
                        'or reach out to the Limbach IT HelpDesk for any questions',
                },
            })
            .data('kendoUpload');

        $(docs.wrapper).addClass('k-hide-actions');

        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const showGrid = () => {
    bondRequestGridDisplay(true);
};

const validate = () => {
    const reqFields = $('[data-required="true"]');
    const failures = [];
    reqFields.each((i, e) => {
        const that = $(e);
        const thatValue = that.val();
        if (!thatValue || thatValue === '' || thatValue === -1) {
            failures.push(that)
            if (that.hasClass('k-textbox')) {
                that.addClass('fieldValidationError');
            } else {
                that.parent().addClass('fieldValidationError');
            }
            // that.parent().addClass('fieldValidationError');
        }
    });
    return failures.length === 0;
};

const setFormIsSubmitting = (value) => {
    submitting = value;

    const $submitButtons = formContainer.find('button[type="submit"], button.js-submit');
    const $cancelButtons = formContainer.find('button.js-cancel');
    const $overlayTarget = formContainer.find('form#newBondRequest .topics').first();

    $submitButtons
        .prop('disabled', value)
        .text(value ? 'Submitting...' : 'Submit Bond Request');

    $cancelButtons.prop('disabled', value);

    if ($overlayTarget.length) {
        kendo.ui.progress($overlayTarget, value);
    } else {
        kendo.ui.progress(formContainer.find('form#newBondRequest'), value);
    }
}

const saveAttachments = () => new Promise((resolve, reject) => {
    const fileList = $('.js-documentation').data('kendoUpload').getFiles();

    if (fileList.length === 0) {
        resolve([]);
        return;
    }

    const files = [];

    $.each(fileList, (i, f) => {
        let name = f.name;
        if (name.includes(f.extension)) name = name.replace(f.extension, '');
        files.push({
            Name: name,
            Extension: f.extension,
            Size: f.size,
            Data: f.rawFile
        });
    });

    const attachments = {
        CanAdd: true,
        AttachmentList: files
    };

    const fd = new FormData();

    Object.entries(attachments).forEach(([key, value]) => {
        if (key === 'AttachmentList') {
            value.forEach((attachment, i) => {
                Object.entries(attachment).forEach(([secondaryKey, secondaryValue]) => {
                    if (secondaryKey === 'Data' || secondaryKey === 'DataBase64' || secondaryKey === 'File')
                        fd.append(`[${key}][${i}].${secondaryKey}`, secondaryValue);
                    else fd.append(`[${key}][${i}].${secondaryKey}`, secondaryValue.toString());
                });
            });
        } else fd.append(key, value.toString());
    });

    $.post({
        url: '/Sales/BondRequests/SaveBondRequestAttachments',
        data: fd,
        processData: false,
        contentType: false,
        success(d) {
            if (d.success) {
                resolve(d.attachmentIds);
            } else {
                showErrorNotification(d.message);
                reject(d);
            }
        },
        error(jqXHR, textStatus) {
            showErrorNotification('Could not save attachments. Please try again.');
            reject(new Error(textStatus));
        }
    });
});

const saveForm = async (e) => {
    e.preventDefault();
    const valid = validate();

    if (!valid) {
        showErrorNotification('Required fields are missing.');
        return false;
    }

    if (submitting) {
        return false;
    }

    setFormIsSubmitting(true);

    let attachmentIds;
    try {
        attachmentIds = await saveAttachments();
    } catch {
        setFormIsSubmitting(false);
        return false;
    }

    const form = formContainer.find('form');
    const formData = form.serializeArray();
    // update checkboxes to boolean
    const checkboxes = $('input[type="checkbox"]');
    checkboxes.each((i, ele) => {
        const cbName = $(ele).prop('name');
        let obj = formData.find(e => e.name === cbName);
        if (!obj) {
            obj = {name: cbName, value: false};
            formData.push(obj);
        } else obj.value = obj.value === 'on';
    });

    attachmentIds.forEach((id, i) => {
        formData.push({name: `AttachmentIds[${i}]`, value: id});
    });

    await new Promise((resolve) => {
        $.post({
            url: '/Sales/BondRequests/CreateBondRequest',
            data: formData,
            success(d) {
                if (!d.success) {
                    showErrorNotification(d.reason);
                    resolve(false);
                    setFormIsSubmitting(false);
                    return;
                }
                showSuccessNotification(d.reason);
                window.location.href = `/Sales/BondRequests/BondRequestInfo?id=${d.id}`;
                resolve(true);
            },
            error(jqXHR) {
                setFormIsSubmitting(false);
                const reason = jqXHR?.responseJSON?.reason ?? 'Could not submit bond request. Please try again.';
                showErrorNotification(reason);
                resolve(false);
            }
        });
    });
    return true;
};

const cancelForm = (e) => {
    e.preventDefault();
    formContainer.hide();
    showGrid();
    showNewButton();
    asideMenu.hide();
};

const formOptions = async () => {
    try {
        const sub = $('.js-submit');
        const cancel = $('.js-cancel');
        sub.on('click', saveForm);
        cancel.on('click', cancelForm);

        formContainer.on('keydown', 'input:not([type="submit"]):not([type="button"])', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

// setFormContainer is used in testing to set the form container element
export const setFormContainer = (c) => { formContainer = c; };
// Exports for testing
export { saveAttachments, saveForm, setFormIsSubmitting };

export default async (container, aside) => {
    formContainer = container;
    asideMenu = aside;
    return await Promise.allSettled([
        nbAutocomplete(),
        projectAutocomplete(),
        dropdowns(),
        currencies(),
        profit(),
        bidPercentage(),
        dates(),
        originalBonds(),
        states(),
        specialBondForm(),
        documentation(),
        formOptions(),
        tooltips()
    ]);
};
